import { css } from "@emotion/react";

export const slatePlaceholderStyles = css`
  position: absolute;
  pointer-events: none;
  width: 100%;
  max-width: 100%;
  display: block;
  opacity: 0.333;
  user-select: none;
  text-decoration: none;
`;
